import React, { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Upload, message, Button, Input, Form, Table } from "antd";
import { apiEndpoint } from "@iso/lib/helpers/endpoint";
import { authHeader } from "@iso/lib/helpers/authHeader";
import SignaturePadWrapper from "./SignaturePad.style";
import SignatureComponentWrapper from "./SignatureComponent.style";
import { isDesktop, isTablet } from "react-device-detect";
import { imageService, publicFormService } from "@iso/services";
import { commonHelper } from "@iso/lib/helpers/commonHelper";
import { PlusOutlined, DeleteFilled, SearchOutlined } from "@ant-design/icons";
import IntlMessages from "@iso/components/utility/intlMessages";
import { set } from "lodash";
import queryString from "query-string";
import SignaturePadContent from "./SignaturePadContent";

const SignaturePad = ({ value, onChange, initialValue = [], tableName = 'Name' }) => {
  const { dataURLtoFile, convertBase64 } = commonHelper;
  const sigCanvas = useRef();
  const uploadButton = useRef();
  const [signatures, setSignatures] = useState(value ? value.signatures : []);
  const [name, setName] = useState("");
  const [errMessage, setErrMessage] = useState();
  const [isShowModal, setIsShowModal] = useState(false);
  const [viewedSignature, setViewedSignature] = useState();
  const formToken = queryString.parse(window.location.search).token || "";
  const isPublicUploadImage = (window.location.pathname === '/visitor-form' || window.location.pathname === '/contractor-form' || window.location.pathname === '/public-form') && formToken

  const save = () => {
    if (!name.trim()) {
      setErrMessage("This field is required");
      return;
    }
    const URL = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
    const formData = new FormData();
    formData.append("Image[file]", dataURLtoFile(URL, "signature"));
    if(isPublicUploadImage){
      formData.append("type", "signatures");
      formData.append("form_token", formToken);
    }

    const uploadServiceFn = isPublicUploadImage ? publicFormService.uploadImage(formData) : imageService.storeOrUpdate(formData)

    uploadServiceFn.then((res) => {
      const signatureList = [
        ...signatures,
        ...[
          {
            name: name,
            imageId: res.image.id,
            path: res.image.path,
            full_path: res.image.full_path,
          },
        ],
      ];
      setSignatures(signatureList);
      onChange({ signatures: signatureList });
      setIsShowModal(false);
    });
  };

  useEffect(()=>{
    setSignatures(value ? value.signatures : [])
  }, [value])

  const uploadSignature = () => {
    uploadButton.current.click();
  };

  const handleCancel = () => {
    setIsShowModal(false);
  };

  const openModal = () => {
    setName("");
    setViewedSignature(null);
    setErrMessage(null);
    sigCanvas.current && sigCanvas.current.clear();
    setIsShowModal(true);
  };

  const uploadProps = {
    name: "Image[file]",
    action: isPublicUploadImage ? `${apiEndpoint.visitorForm}/upload-image` : apiEndpoint.images,
    headers: authHeader(true),
    data: {
      type: 'signatures'
    },
    beforeUpload: async (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("Image must smaller than 2MB!");
      }
      sigCanvas.current.fromDataURL(await convertBase64(file));
      return false;
    },
  };

  const columns = [
    {
      title: tableName,
      dataIndex: "name",
      key: "name",
      render: (text) => <div style={{ width: "90px" }}>{text}</div>,
    },
    {
      title: "",
      dataIndex: "imageId",
      key: "imageId",
      render: (imageId) => (
        <div className="signature-action-table">
          <DeleteFilled
            onClick={() => {
              removeSignature(imageId);
            }}
          />
          <SearchOutlined
            style={{ marginLeft: "10px" }}
            onClick={() => {
              viewSignature(imageId);
            }}
          />
        </div>
      ),
    },
  ];

  const removeSignature = (imageId) => {
    const newSignatureList = signatures.filter((signature) => {
      return signature.imageId != imageId;
    });
    setSignatures(newSignatureList);
    onChange({ signatures: newSignatureList });
    imageService.destroy(imageId);
    setIsShowModal(false);

  };

  const viewSignature = (imageId) => {
    const sig = signatures.filter((signature) => {
      return signature.imageId == imageId;
    });
    if (sig.length) {
      setViewedSignature(sig[0]);
      setName(sig[0]["name"]);
      setIsShowModal(true);
    }
  };

  const handleChangeName = (value) => {
    if (!value.trim()) {
      setErrMessage("This field is required");
    }
    setName(value);
  };

  return (
    <div>
      <Table
        className="signature-table"
        columns={columns}
        dataSource={signatures}
        containerId="containerBox"
        pagination={false}
      />
      <Button
        style={{ marginTop: "10px", marginBottom: "10px" }}
        icon={<PlusOutlined />}
        type="primary"
        className="btn-success"
        size="large"
        onClick={openModal}
      >
        <IntlMessages id="formPage.modal.addSignature" />
      </Button>
      <SignaturePadContent 
        isShowModal={isShowModal}
        setIsShowModal={setIsShowModal}
        name={name}
        setName={setName}
        viewedSignature={viewedSignature}
        handleChangeName={handleChangeName}
        errMessage={errMessage}
        setErrMessage={setErrMessage}
        sigCanvas={sigCanvas}
        isDesktop={isDesktop}
        isTablet={isTablet}
        save={save}
        handleCancel={handleCancel}
        removeSignature={removeSignature}
        uploadSignature={uploadSignature}
        uploadProps={uploadProps}
        uploadButton={uploadButton}
      />
    </div>
  );
};

export default SignaturePad;
